import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M7.917 11.458c0 .809.625 1.459 1.391 1.459h1.567c.666 0 1.208-.567 1.208-1.275 0-.759-.333-1.034-.825-1.209L8.75 9.558c-.492-.175-.825-.441-.825-1.208 0-.7.542-1.275 1.208-1.275H10.7c.767 0 1.392.65 1.392 1.458M10 6.25v7.5"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M18.333 10c0 4.6-3.733 8.333-8.333 8.333A8.336 8.336 0 0 1 1.667 10C1.667 5.4 5.4 1.667 10 1.667M14.167 2.5v3.333H17.5M18.333 1.667l-4.166 4.166"
    }, null, -1)
  ]))]))
}
export default { render: render }